import { Warning, X } from '@phosphor-icons/react';
import { useState } from 'react';
import { Link, useLocation, useSearchParams } from 'react-router';
import { Button, buttonStyles } from '@skupreme/shared/ui';
import { OrangeWarning } from '@elements/Common';

/** The orange bar asking to update a declined card; it can be dismissed. */
export function PaymentDeclinedWarning({ failureMessage = '' }) {
  const [showMessage, setShowMessage] = useState(true);
  const [searchParams] = useSearchParams();
  const location = useLocation();

  if (!showMessage) {
    return null;
  }

  const onWalletTab =
    location.pathname === '/app/settings' &&
    searchParams.get('tab') === 'wallet';

  return (
    <div className="sk:px-5">
      <OrangeWarning className="payment-warning-wrapper sk:mt-[15px] sk:mb-0">
        <div className="sk:flex!">
          <Warning weight="bold" size={16} className="sk:mr-2!" color="#fff" />
          <h3 className="tip">
            {failureMessage ||
              'Orders cannot be processed because your default payment method is being declined'}
          </h3>
        </div>
        <div>
          {!onWalletTab && (
            <Link
              to="/app/settings/?tab=wallet"
              className={buttonStyles({ variant: 'primary', size: 'lg' })}
            >
              Update Payment Method
            </Link>
          )}
          <Button
            variant="ghost"
            shape="circle"
            aria-label="Dismiss"
            onPress={() => setShowMessage(false)}
            className="sk:ml-4 sk:text-white sk:hover:text-white"
          >
            <X size={24} />
          </Button>
        </div>
      </OrangeWarning>
    </div>
  );
}
